import { Injectable } from '@angular/core';
import type { SafeHtml } from '@angular/platform-browser';

import { I18nService } from '@recruitee/i18n';

import { TERMS_URL } from './constants';
import { UrlInTranslationsPipe } from '../../common';

@Injectable({ providedIn: 'root' })
export class AdpHelpers {
  constructor(
    protected i18n: I18nService,
    protected urlInTranslationsPipe: UrlInTranslationsPipe,
  ) {}

  public claimsHeading(): SafeHtml {
    return this.urlInTranslationsPipe.transform(
      this.i18n.translate('rti.adp.settings.legal_dialog.special_terms_heading'),
      { a: 'target=_blank href=' + TERMS_URL },
    );
  }

  public claims(): SafeHtml[] {
    return [...Array(13).keys()].map(n =>
      this.i18n.translate(`rti.adp.settings.legal_dialog.special_terms.${n + 1}`),
    );
  }
}
